<template>
  <div class="ehs-table-header">
    <div v-if="selectable" class="ehs-data-table-header__select"></div>
    <div
      v-for="column in columns"
      :key="column.property"
      class="ehs-table-header-cell"
      :class="{
        'ehs-table-header-cell--fixed-width': !!column.width,
        [`w-${column.width}`]: column.width !== undefined,
      }"
      :style="`flex-grow: ${!column.width ? column.flex : 0};`"
    >
      <div class="truncate text-xs uppercase opacity-75 tracking-wider font-medium">
        <span>
          {{ column.label || column.property }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EHSTableHeader',
  props: {
    columns: Array,
    selectable: Boolean,
  },
}
</script>

<style scoped>
.ehs-table-header {
  @apply flex flex-shrink-0 h-12;
  @apply font-medium;
  @apply bg-white;
}
.ehs-table-header-cell {
  @apply flex flex-1 overflow-x-hidden px-4 h-12 items-center border-b;
  @apply select-none;
  min-width: 2rem;
}
.ehs-table-header-cell.ehs-table-header-cell--fixed-width {
  flex: 0 0 auto;
}
.ehs-data-table-header__select {
  @apply flex h-full w-12 pl-1 items-center border-b;
}
</style>
